import { styled } from "@mui/material"
import { Chip } from "@pharmupp/p3-front-commons"

export const CreatorChip = styled(Chip)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
}))
CreatorChip.defaultProps = {
  size: "small",
  variant: "outlined",
}
